// @flow
import React from 'react';
import classnames from 'classnames';

import { Title, type TitleProps } from 'Components/frameworks/title/Title';

type Props = TitleProps & {
  isExclusiveCollection?: boolean,
};

export const LineTitle = ({ className, isExclusiveCollection, ...rest }: Props) => (
  <Title
    {...rest}
    className={classnames('mb-4 md:mb-6', className)}
    theme={isExclusiveCollection ? 'title-serif-7' : 'title-brand-1'}
  />
);
